<template>
  <v-container text-xs-center>
    <div id="app">
      <BaseTable
        :tableHeaders="headers"
        :tableItems="usersList.edges"
        :tableSearch="search"
        :tableLoading="loading"
      >
        <template v-slot:table-top>
          <BaseToolbar toolbarTitle="Users">
            <template v-slot:toolbarSearch>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search User"
                single-line
                hide-details
              ></v-text-field>
            </template>
            <template v-slot:toolbarBtn>
              <v-dialog
                v-model="dialog"
                max-width="700px"
                :retain-focus="false"
                persistent
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" dark v-on="on" v-bind="attrs">{{
                    formTitle
                  }}</v-btn>
                </template>
              </v-dialog>
            </template>
          </BaseToolbar>
        </template>
        <template v-slot:table-actions="{ actionItem }">
          <v-icon small class="mr-2" @click="edit(actionItem.node)">
            edit
          </v-icon>
          <v-icon small @click="deleteUser(actionItem.node.userId)">
            delete
          </v-icon>
        </template>
      </BaseTable>
      <!--Add new user dialog-->
      <v-dialog
        v-model="dialog"
        :retain-focus="false"
        max-width="500px"
        persistent
      >
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="userData.userName"
                    label="User name"
                    :rules="nameRules"
                    :counter="50"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="userData.userEmail"
                    label="User email"
                    :rules="emailRules"
                    :counter="50"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="userData.role"
                    label="User role"
                    :rules="requiredRule"
                    :items="['Administrator', 'user']"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="userData.language"
                    label="Language"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="userData.birthDate"
                        label="Birth Date"
                        prepend-inner-icon="event"
                        v-on="on"
                        v-bind="attrs"
                        readonly
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="userData.birthDate"
                      @input="menu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    v-model="userData.country"
                    :items="countryList"
                    label="Country"
                    :rules="requiredRule"
                    item-value="node.valId"
                    item-text="node.valDesc"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    v-model="userData.gender"
                    :items="['male', 'female']"
                    label="Gender"
                    :rules="requiredRule"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-switch
                    color="secondary"
                    v-model="userData.state"
                    label="State"
                  ></v-switch>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" text @click="close">Cancel</v-btn>
            <v-btn
              :disabled="!isFormValid"
              color="secondary"
              text
              @click="actionName"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
//TODO Add new user issue
import { mapGetters, mapActions } from "vuex";
import { validationRules } from "../../../constants/global";
import { userTableHeaders, userDefaultData } from "../../../constants/users";
import { randomInteger } from "../../../_helpers/index";
import { nanoid } from "nanoid";
import BaseToolbar from "../../base/BaseToolbar.vue";
import BaseTable from "../../base/BaseTable.vue";

export default {
  components: { BaseToolbar, BaseTable },
  data() {
    return {
      loading: true,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      search: "",
      isFormValid: true,
      menu: false,
      on: true,
      dialog: false,
      nameRules: validationRules.name,
      requiredRule: validationRules.required,
      emailRules: validationRules.email,
      headers: userTableHeaders,
      //TODO Take out this hardcode
      subHeaders: [
        // { text: "SeqNo", align: "left", sortable: true, value: "node.seqNo"},
        { text: "UserId", value: "node.club.clubName" },
        //{ text: "ClubId", value: "node.clubId" },
        { text: "Access Level", value: "node.accessLevel" }
      ],
      additionalData: null,
      editedIndex: -1,
      userData: {
        userName: "",
        userEmail: "",
        gender: "",
        birthDate: "",
        country: "",
        state: "",
        language: "",
        role: ""
      },
      defaultItem: userDefaultData
    };
  },
  created() {
    this.$store
      .dispatch("allUser")
      .then(() => (this.loading = false))
      .catch(error => {
        console.error(error);
        this.loading = false;
      });
  },
  computed: {
    ...mapGetters(["usersList", "categoryValue"]),
    formTitle() {
      return this.editedIndex === -1 ? "New User" : "Edit User";
    },
    // eslint-disable-next-line vue/return-in-computed-property
    countryList() {
      if (this.categoryValue.edges) {
        return this.categoryValue.edges.filter(
          category => category.node.category.catName === "COUNTRY_LIST"
        );
      }
    },
    actionName() {
      return this.editedIndex === -1 ? this.addNewUser : this.editCurrentUser;
    },
    getUserCountry() {
      if (this.countryList.length > 0) {
        return this.countryList.filter(
          c => +c.node.valId === +this.userData.country
        )[0].node.valName;
      } else {
        return "Loading...";
      }
    }
  },
  methods: {
    ...mapActions(["userMerge", "userUpdate", "userDelete"]),
    edit(user) {
      console.log(user);
      this.editedIndex = 1;
      this.userData = user;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.userData = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      this.additionalData = null;
    },
    addNewUser() {
      this.loading = true;
      this.userMerge({
        //TODO Set first number how last id in last user from usersList
        userId: Number(randomInteger(1, 1250)),
        userName: String(this.userData.name),
        password: "SportEcoSys123",
        passwordResetcode: String(nanoid()),
        photo: "userPhoto",
        role: String(this.userData.role),
        userEmail: String(this.userData.email),
        birthDate: this.userData.birthDate,
        // createDate: String(this.moment.format("YYYY-MM-DD")),
        gender: String(this.userData.gender),
        state: this.userData.state ? "active" : "passive",
        country: String(this.getUserCountry),
        language: String(this.userData.language),
        updateSource: "test data"
      }).then(() => {
        this.loading = false;
        this.close();
        this.$toast.success("User has been added");
      });
    },
    editCurrentUser() {
      this.loading = true;
      this.userUpdate({
        ...this.userData,
        updateSource: "Test data"
      }).then(() => {
        this.loading = false;
        this.close();
        this.$toast.info("User has been updated");
      });
    },
    deleteUser(id) {
      this.loading = true;
      console.log(id);
      this.userDelete({ userId: +id })
        .then(() => {
          this.loading = false;
          this.$toast.error("User has been deleted");
        })
        .catch(error => {
          console.error(error);
          this.loading = false;
        });
    }
  }
};
</script>
